import styled from "styled-components";

export const ContactInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 28px 17px;
  margin-bottom: 20px;
  width: 100%;
  height: auto;
  gap: 9px;
  background: #c4c4c4;
`;

export const InfoForm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  height: auto;
`;
export const Phone = styled.p`
  padding: 0;
  margin: 0;
  font-weight: 700;
  font-size: 17px;
  line-height: 21px;
  color: #000000;
`;
export const InfoText = styled.p`
  padding: 0;
  margin: 0;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: #000000;
`;
export const DocumentsBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin: 25px 0;
  width: 100%;
  height: auto;
`;

export const Payed = styled.p`
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  color: #000000;
`;
